import React from "react";

const CandidateDetailsOverviewSkeleton = () => {
  return (
    <div>
      <>
        <div className="flex justify-between mb-2 gap-tsm">
          <div className="w-32 h-6 rounded-[44px] skeleton-bg 2"></div>
          <div className="w-6 h-6 rounded-[44px] skeleton-bg 2"></div>
        </div>
        <div className="mb-2 ">
          <div className="w-full h-12 rounded-[10px] skeleton-bg 2"></div>
        </div>

        <div className="w-1/2 h-6 rounded-[44px] skeleton-bg mb-2"></div>

        <div className="flex gap-2">
          <div className="w-1/3 h-6 rounded-[44px] skeleton-bg "></div>

          <div className="w-1/3 h-6 rounded-[44px] skeleton-bg"></div>
        </div>
        <div className="flex flex-col gap-tm2 mt-tsm">
          <div className="flex gap-tnano">
            <div className="w-4 h-4 rounded-lg skeleton-bg"></div>
            <p className="h-4 rounded-lg w-52 skeleton-bg"></p>
          </div>
          <div className="flex gap-tnano">
            <div className="w-4 h-4 rounded-lg skeleton-bg"></div>
            <p className="w-48 h-4 rounded-lg skeleton-bg"></p>
          </div>
          <div className="flex gap-tnano">
            <div className="w-4 h-4 rounded-lg skeleton-bg"></div>
            <p className="h-4 rounded-lg w-44 skeleton-bg"></p>
          </div>
          <div className="flex gap-tnano">
            <div className="w-4 h-4 rounded-lg skeleton-bg"></div>
            <p className="h-4 rounded-lg w-36 skeleton-bg"></p>
          </div>
          <div className="flex gap-tnano">
            <div className="flex gap-2">
              <div className="w-4 h-4 rounded-lg skeleton-bg"></div>
              <p className="h-4 rounded-lg w-28 skeleton-bg"></p>
            </div>
          </div>
        </div>

        <div className="flex gap-4 mt-4">
          <p className="w-6 h-6 rounded-full skeleton-bg"></p>
          <p className="w-6 h-6 rounded-full skeleton-bg"></p>
          <p className="w-6 h-6 rounded-full skeleton-bg"></p>
          <p className="w-6 h-6 rounded-full skeleton-bg"></p>
        </div>
      </>
    </div>
  );
};

export default CandidateDetailsOverviewSkeleton;
